import {Component, Input, TemplateRef, ViewChild} from '@angular/core';

import {Customer, IpData, User} from '../../../../core/models';
import {UsersService} from '../../../../core/services/users.service';
import {UserInfoDialogComponent} from '../user-info-dialog/user-info-dialog.component';
import {MatDialog} from "@angular/material/dialog";
import {
  UserInviteDialogComponent,
  UserInviteDialogData,
  UserInviteDialogOutput
} from '../user-invite-dialog/user-invite-dialog.component';

@Component({
    selector: 'app-user-card',
    templateUrl: './user-card.component.html',
    styleUrls: ['./user-card.component.scss'],
    standalone: false
})
export class UserCardComponent  {

  @ViewChild('ipDialog') ipDialog = {} as TemplateRef<IpData>;

  @Input() user: User;
  @Input() customer: Customer;

  constructor(private usersService: UsersService,
              private dialog: MatDialog) {}

  showIpInfo(): void {
    if(!this.user.last_sign_in_ip) {
      return;
    }
    this.usersService.getIpData(this.user.last_sign_in_ip)
      .subscribe(data => {
        console.log('data => ', data);
        this.dialog.open(this.ipDialog, { data : data });
      });
  }

  showPermissions(): void {
    this.dialog.open(UserInfoDialogComponent, {
      data: {
        user: this.user
      },
      width: '800px',
    });
  }

  resetOtp(): void {
    this.dialog.open<UserInviteDialogComponent, UserInviteDialogData, UserInviteDialogOutput>(
      UserInviteDialogComponent,
      {
        data: {
          user: this.user
        },
        width: '800px'
      }
    ).afterClosed().subscribe(result => {
      if (!result) return;

      this.usersService.resetOtp(this.user.id, result, this.customer.subdomain).subscribe();
    });
  }
}
